var map = {
	"./DhammaApp.png": 3416,
	"./ENGMMDictionary.png": 7754,
	"./ENGMMDictionaryApp.png": 2943,
	"./ExamResultApp.png": 5112,
	"./KBZ-Bank.jpg": 524,
	"./KBZConnect.png": 6895,
	"./KBZMobileBanking.png": 512,
	"./KBZPay.png": 496,
	"./MMCalendarApp.png": 9083,
	"./MMENGDictionaryApp.png": 1340,
	"./MMThetponeApp.png": 3144,
	"./MYPROFILE.png": 1795,
	"./MovieVault.png": 6324,
	"./MovieVaultAPI.png": 6512,
	"./MyHealthApp.png": 1979,
	"./PRODUCTMNG.png": 4511,
	"./Portfolio.png": 9522,
	"./RESTAURANT.png": 1554,
	"./RESTAURANTAPI.png": 1751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6308;